const NE_EI = {
  email: 'test@email.com',
};

export { NE_EI };
